import { BotDefaultLocale, NlpModel } from '@feedyou/schema'
import { toast } from 'react-toastify'
import { toastNlpTestError, toastNlpTestStarted } from '../toasts'
import { fetchNlpModelsTestResult } from '../../nlp-analyzer'

import { showTestResults } from './showTestResults'

type RunNlpModelsTestParams = {
  models: NlpModel[]
  input: string
  defaultLocale: BotDefaultLocale | undefined
  authenticationBotId: string
  onlyQueryAgainstExpectedModel?: boolean
}

export async function runNlpModelsTest({
  models,
  input,
  defaultLocale,
  authenticationBotId,
  onlyQueryAgainstExpectedModel
}: RunNlpModelsTestParams) {
  const toastId = toastNlpTestStarted()

  const cases = input.split('\n').map(line => {
    // 3-column input (utterance, modelId, intentId)
    let [utterance = '', modelId = '', intentId = ''] = line.trim().split('\t')

    // 2-column input (utterance, ${modelId}---${intentId})
    if (!intentId && modelId?.includes('---')) {
      intentId = modelId.split('---')[1]
      modelId = modelId.split('---')[0]
    }
    // 2-column input (utterance, intentId) for fuzzy mode
    else if (!intentId && modelId) {
      intentId = modelId
      modelId = models[0]?.id // Expecting just one model in fuzzy
    }

    return { utterance, modelId, intentId }
  })

  try {
    const results = await fetchNlpModelsTestResult(
      models,
      defaultLocale,
      cases,
      authenticationBotId,
      !!onlyQueryAgainstExpectedModel
    )
    toast.dismiss(toastId)
    await showTestResults(results)
  } catch (error) {
    toast.dismiss(toastId)
    console.error('Failed to run NLP test', error)
    toastNlpTestError()
  }
}
